import { createMemo, Show } from "solid-js";
import { BriefQuestionResponseSheet } from "./BriefQuestionResponseSheet";
import type { DeliveryBrief } from "./briefTypes";

export function BriefQuestionResponseOverlay(props: {
  brief: () => DeliveryBrief | null;
  questionId: () => string | null;
  returnFocus: () => HTMLElement | null;
  onSave: (id: string, response: string, confirmationSource: string) => void;
  onClose: () => void;
}) {
  const question = createMemo(() =>
    props.brief()?.openQuestions.find((item) => item.id === props.questionId()),
  );

  return (
    <Show when={question()} keyed>
      {(activeQuestion) => (
        <BriefQuestionResponseSheet
          question={activeQuestion}
          returnFocus={props.returnFocus()}
          onSave={(response, confirmationSource) => {
            props.onSave(activeQuestion.id, response, confirmationSource);
            props.onClose();
          }}
          onClose={props.onClose}
        />
      )}
    </Show>
  );
}
